function mapOrderList(apiResponse) {
  const { status, ...rest } = apiResponse
  return {
    status: status.toLowerCase(),
    ...rest,
  }
}

export { mapOrderList }
